import styled from 'styled-components';
import devices from 'style/breakpoints';
import colors from 'style/palette/palette';


export const CardContent = styled.div`

    display: flex;
    align-items: center;
    justify-content: flex-start;
    
    flex-direction: column;

    width: 100%;
    height: 100%;

    padding: 30px 30px 100px 30px;
    gap: 40px;

    background-color: ${colors.veryDarkGrey};
    border-radius: 15px;

    overflow: auto;

    ::-webkit-scrollbar {
            display: none;
        }

    -ms-overflow-style: none;
    scrollbar-width: none;

    @media ${devices.tablet} {
        padding: 35px 45px 50px;
    }
`;

export const CloseButton = styled.button`

    margin: 0;
    padding: 0;

    background-color: ${colors.transparent};
    border: none;

    cursor: pointer;

    @media  (max-height: 850px){
        margin-top: 200px;
    }

    @media  (max-height: 600px){
        margin-top: 450px;
    }
`;
